import { render } from "./LoginRight.vue?vue&type=template&id=1424c43d&scoped=true"
import script from "./LoginRight.vue?vue&type=script&lang=js"
export * from "./LoginRight.vue?vue&type=script&lang=js"

import "./LoginRight.vue?vue&type=style&index=0&id=1424c43d&scoped=true&lang=scss"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1424c43d"]])

export default __exports__